import axios from 'axios';

const baseURL = 'https://afrika-raaga.com';
// const baseURL = 'http://127.0.0.1:8000';

// Instance Axios principale
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  // Supprimer withCredentials pour le mode token
});

// Intercepteur pour ajouter le token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs 401
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Si le token est invalide, nettoyer et rediriger
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      delete axiosInstance.defaults.headers.common['Authorization'];
      
      // Rediriger vers login seulement si on n'y est pas déjà
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

// Configurer le token au démarrage de l'app
const initializeToken = () => {
  const token = localStorage.getItem('token');
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
};

// Appeler au démarrage
initializeToken();

export default axiosInstance;
export { baseURL };